/* eslint-disable import/no-named-as-default */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import qualificationTechniquesType from "./types/qualificationTechniquesType";
import EditButton from "../shared/button/EditButton";
import QualificationsEdit from "./EditForms/QualificationsEdit";
import {
  Wrapper,
  Title,
  TitleText,
  Tooltip,
  Body,
  Paragraph,
  Technique,
  TechniqueText,
  SeeMore,
  SeeMoreButton,
} from "./styles/candidate-qualification-styles";

export class CandidateQualification extends Component {
  state = {
    editQualificationsActive: false,
  };

  toggleEditQualifications = () => {
    this.setState(({ editQualificationsActive }) => ({
      editQualificationsActive: !editQualificationsActive,
    }));
  };

  render() {
    const { qualificationTechniques, currentUser, toggleQualificationModal } =
      this.props;
    const { editQualificationsActive } = this.state;
    const techniquesCount = qualificationTechniques.length;

    return (
      <Fragment>
        {editQualificationsActive && (
          <QualificationsEdit
            toggleEditQualifications={this.toggleEditQualifications}
          />
        )}
        <Wrapper className="animated delay-6 fadeIn">
          {currentUser.isRecruiter && (
            <EditButton
              onClickAction={this.toggleEditQualifications}
              top={8}
              right={10}
            />
          )}
          <Title>
            <TitleText>Candidate Qualification</TitleText>
            <Tooltip
              data-tip="e.g. <strong>face to face meeting</strong>,<br><strong>phone interview</strong> etc."
              data-for="qualifications-tooltip"
            >
              <FontAwesomeIcon icon={faInfoCircle} />
            </Tooltip>
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="solid"
              aria-haspopup="true"
              id="qualifications-tooltip"
            />
          </Title>
          {techniquesCount < 1 ? (
            <Body noData>
              {currentUser.isRecruiter
                ? "Please add your information here"
                : "We're working on building our profile right now"}
            </Body>
          ) : (
            <Body>
              <Paragraph>
                I qualify my candidates using the following techniques:
              </Paragraph>
              {qualificationTechniques.map((technique) => (
                <Technique key={technique ? technique.replace(" ", "-") : ""}>
                  <FontAwesomeIcon icon={faCheck} />
                  <TechniqueText data-test-id="user-qualification">
                    {technique}
                  </TechniqueText>
                </Technique>
              ))}
            </Body>
          )}
          {techniquesCount > 3 && (
            <SeeMore>
              <SeeMoreButton onClick={() => toggleQualificationModal()}>
                see more
              </SeeMoreButton>
            </SeeMore>
          )}
        </Wrapper>
      </Fragment>
    );
  }
}

CandidateQualification.propTypes = {
  qualificationTechniques: qualificationTechniquesType.isRequired,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  currentUser: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  toggleQualificationModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  qualificationTechniques:
    state.agencyProfile.profileData.qualificationTechniques,
  user: state.agencyProfile.profileData.user,
  currentUser: state.agencyProfile.profileData.currentUser,
});

export default connect(mapStateToProps, {})(CandidateQualification);
